<script>
import FormsValidatedInput from "@/components/Forms/ValidatedInput.vue";
import IconButton from "@/components/shared/IconButton.vue";
import { put } from "@/requests/server";

export default {
  name: "LinkPayoutToKiwiliForm",
  components: { IconButton, FormsValidatedInput },
  props: {
    payout: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      kiwiliExpenseId: this.payout.kiwili_expense_id,
    };
  },
  methods: {
    async savePayout() {
      await put(
        `/payouts/${this.payout.id}`,
        {
          kiwili_expense_id: this.kiwiliExpenseId,
        },
        {
          notifications: {
            action: this.$t(
              "components.admin.link_payout_to_kiwili_form.notifications.update_payment_request.action"
            ),
          },
        }
      );
      this.$emit("saved");
    },
  },
};
</script>

<template>
  <b-form>
    <forms-validated-input
      v-model="kiwiliExpenseId"
      type="text"
      name="kiwili-expense-id"
      :label="$t('components.admin.link_payout_to_kiwili_form.kiwili_expense_id_label')"
      :rules="{
        required: true,
      }"
    ></forms-validated-input>
    <icon-button role="save" :onclick="savePayout">{{ $t("forms.save") | capitalize }}</icon-button>
  </b-form>
</template>

<style scoped lang="scss"></style>
